import {Injectable, TemplateRef} from '@angular/core';
import {asapScheduler, BehaviorSubject, distinctUntilChanged, observeOn} from 'rxjs';

/** Renders search controls beside quick navigation, outside ion-content's containing block. */
@Injectable({providedIn: 'root'})
export class SearchOverlayService {
  navigationVisible = false;
  private readonly current = new BehaviorSubject<TemplateRef<unknown> | null>(null);
  readonly template$ = this.current.pipe(distinctUntilChanged(), observeOn(asapScheduler));
  register(template: TemplateRef<unknown>): void { this.navigationVisible = false; this.current.next(template); }
  release(template: TemplateRef<unknown>): void {
    if (this.current.value === template) this.current.next(null);
  }
}
